import { createActionCreator } from '@pressreader/appstore';
import { CoBrandingInfo, ISponsor } from '@pressreader/sponsorship-types';

import { MODULE_NAME } from '../constants';

const prefix = `${MODULE_NAME}/`;

const loadHotspotInfoAction = createActionCreator<{ userChanged?: boolean }>(`${prefix}load_hotspot_info`);
const loadHotspotInfoCancelled = createActionCreator(`${prefix}load_hotspot_info_cancelled`);

const toggleHotspotAction = createActionCreator<{ enabled: boolean }>(`${prefix}toggle_hotspot`);

const openHotspotAction = createActionCreator(`${prefix}open_hotspot`);

const loadHotspotInfoDone = createActionCreator<{ sponsor: ISponsor }>(`${prefix}load_hotspot_info_done`);
const loadHotspotInfoFailed = createActionCreator(`${prefix}load_hotspot_info_failed`);

// Content-must-refetch signal: view sagas reload sponsored content on it
// (grep subscribers). Dispatch only for real sponsorship transitions.
const sponsorshipChanged = createActionCreator<{ sponsor: ISponsor }>(`${prefix}sponsorship_changed`);

// Boot-time seed: updates the store exactly like sponsorshipChanged but is
// deliberately NOT part of the content-refetch contract — the initial
// "here is the current sponsor" announcement carries no content change.
const sponsorshipStateSeeded = createActionCreator<{ sponsor: ISponsor }>(`${prefix}sponsorship_state_seeded`);

// Subscribe state-sync consumers (attribute mirrors, banners, state-arrival
// waits) to this pair so they hear the boot seed as well as real transitions;
// content-reload consumers subscribe to sponsorshipChanged alone.
const sponsorshipStateActions = [sponsorshipChanged, sponsorshipStateSeeded];

const loadPartnerInfoAction = createActionCreator(`${prefix}load_partner_info`);
const partnerInfoChanged = createActionCreator<{ partner: CoBrandingInfo }>(`${prefix}partner_info_changed`);

const findAndActivateSponsorShipByLocation = createActionCreator(`${prefix}find_and_activate_sponsorship_by_location`);

const showExpiredHotspotDialogAction = createActionCreator<{ libraryId: number; pin?: string; info?: string; force?: boolean; entry_point: string }>(
    `${prefix}show_expired_hotspot_dialog`,
);

const expirationDialogClosed = createActionCreator<{ reason: boolean | undefined }>(`${prefix}expiration_dialog_closed`);

interface ExpirationEventPayload {
    entry_point: string;
    auth_method: string;
    hotspot_id: string;
}

const expirationReconnectClicked = createActionCreator<ExpirationEventPayload>(`${prefix}expiration_reconnect_clicked`);
const expirationCloseClicked = createActionCreator<ExpirationEventPayload>(`${prefix}expiration_close_clicked`);
const expirationReconnectSuccess = createActionCreator<ExpirationEventPayload>(`${prefix}expiration_reconnect_success`);
const expirationReconnectFailed = createActionCreator<ExpirationEventPayload & { failure_reason: string }>(`${prefix}expiration_reconnect_failed`);

export {
    expirationCloseClicked,
    expirationDialogClosed,
    expirationReconnectClicked,
    expirationReconnectFailed,
    expirationReconnectSuccess,
    findAndActivateSponsorShipByLocation,
    loadHotspotInfoAction,
    loadHotspotInfoCancelled,
    loadHotspotInfoDone,
    loadHotspotInfoFailed,
    loadPartnerInfoAction,
    openHotspotAction,
    partnerInfoChanged,
    showExpiredHotspotDialogAction,
    sponsorshipChanged,
    sponsorshipStateActions,
    sponsorshipStateSeeded,
    toggleHotspotAction,
};
